import { Check } from 'lucide-react';
import { Button } from '~/shared/components/buttons/Button';
import { NavigatePreviousButton } from '../shared/NavigatePreviousButton';
import { NavigateNextButton } from '../shared/NavigateNextButton';
import { SubmitVerbalOrderFormModal } from '~/features/orders/SubmitVerbalOrderFormModal';
import { useGetVisitStatusOptions } from '../queries';
import { useQuery } from '@tanstack/react-query';
import type { FullOrderViewModel } from '@generated';
import { useVisit } from '../VisitContext';

export function VisitOrderFooter({ fullOrder }: { fullOrder: FullOrderViewModel }) {
	const { id } = useVisit();
	const { refetch: refetchVisitStatus } = useQuery(useGetVisitStatusOptions(id));
	return (
		<>
			<div className="flex space-x-2">
				<NavigatePreviousButton />
				<NavigateNextButton label="Skip" />
			</div>
			{fullOrder?.invariants.canBeEdited && (
				<Button
					intent="primary"
					appearance="outline"
					Icon={Check}
					useSuspense
					label="Submit"
					renderModal={closeModal => (
						<SubmitVerbalOrderFormModal
							order={fullOrder}
							closeModal={closeModal}
							onSuccess={() => {
								closeModal();
								refetchVisitStatus();
							}}
						/>
					)}
				/>
			)}
		</>
	);
}
